<template>
  <v-card v-if="vehicle">
    <v-btn color="grey" small class="tariff-headers">
      <h3>{{ $i18n.t("Selling Details") }}</h3>
    </v-btn>
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="6" md="4" lg="4">
        <z-date-picker :label="$i18n.t('Date')" v-model="vehicle.vehicleDetail.soldTo.date" />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <z-currency-select
          :label="$i18n.t('Currency')"
          v-model="vehicle.vehicleDetail.soldTo.currency"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field
          :label="$i18n.t('Amount')"
          type="number"
          v-model="vehicle.vehicleDetail.soldTo.amount"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <z-country-select
          :label="$i18n.t('Country')"
          v-model="vehicle.vehicleDetail.soldTo.address.country"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <z-state-select
          :label="$i18n.t('State')"
          :country="vehicle.vehicleDetail.soldTo.address.country"
          v-model="vehicle.vehicleDetail.soldTo.address.state"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <z-city-select
          :label="$i18n.t('City')"
          :country="vehicle.vehicleDetail.soldTo.address.country"
          v-model="vehicle.vehicleDetail.soldTo.address.city"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field
          :label="$i18n.t('Address')"
          v-model="vehicle.vehicleDetail.soldTo.address.addressLine"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field :label="$i18n.t('Document No')" v-model="vehicle.vehicleDetail.soldTo.docNo" />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field
          :label="$i18n.t('Contact Name')"
          v-model="vehicle.vehicleDetail.soldTo.contact.name"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <z-country-select
          :label="$i18n.t('Contact Country Code')"
          isd
          hideName
          v-model="vehicle.vehicleDetail.soldTo.contact.countryCode"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field
          :label="$i18n.t('Contact Phone')"
          type="number"
          v-model="vehicle.vehicleDetail.soldTo.contact.phone"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field
          :label="$i18n.t('Contact Email')"
          v-model="vehicle.vehicleDetail.soldTo.contact.email"
        />
      </v-col>
    </v-row>
    <v-row style="padding: 10px 10px">
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="4"
        v-for="(picture, index) in vehicle.vehicleDetail.soldTo.attachments"
        :key="index"
      >
        <v-card>
          <a :href="picture.url">
            <v-img
              v-if="isPDF(picture.url)"
              src="@/assets/pdf_format.png"
              aspect-ratio="2"
              class="grey darken-4"
            ></v-img>
            <v-img v-else :src="picture.url" aspect-ratio="2" class="grey darken-4"></v-img>
          </a>
          <v-row class="px-2">
            <v-col cols="12" md="12" lg="12">{{ picture.name }}</v-col>
            <v-col cols="12" md="12" lg="12">
              {{ picture.desc }}
              {{ picture.time | moment("HH:mm DD MMM YYYY") }}
            </v-col>
            <z-confirm-button
              class="close-button"
              color="red"
              fab
              :loading="loading"
              x-small
              :message="$i18n.t('Do you want to remove this attachment ?')"
              @click="deleteSoldImage(picture.time, vehicle._id)"
            >
              <v-icon>mdi-close</v-icon>
            </z-confirm-button>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-row style="padding: 10px 10px">
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-file-input
            chips
            :label="$i18n.t('Attachments')"
            @change="handleSoldAttachmentFileUpload()"
            v-model="soldAttachmentFile"
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="3">
          <v-text-field :label="$i18n.t('Attachment Name')" v-model="soldAttachmentName" />
        </v-col>

        <v-col cols="12" sm="12" md="3" lg="2">
          <v-btn
            v-if="soldAttachmentFile"
            color="green lighten-2"
            small
            v-on:click="uploadSoldFile"
          >
            <h3>{{ $i18n.t("Upload File") }}</h3>
          </v-btn>
        </v-col>
      </v-row>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Sold",
  props: {
    value: {
      default: null,
    },
  },
})
export default class Sold extends Vue {
  vehicle = null;

  get loading() {
    return common.loading;
  }

  async mounted() {
    if (this.value) this.vehicle = this.value;

    if (!this.vehicle) this.vehicle = {};
    if (!this.vehicle.vehicleDetail) this.vehicle.vehicleDetail = {};
    if (!this.vehicle.vehicleDetail.soldTo)
      this.vehicle.vehicleDetail.soldTo = {};
    if (!this.vehicle.vehicleDetail.soldTo.address)
      this.vehicle.vehicleDetail.soldTo.address = {};
    if (!this.vehicle.vehicleDetail.soldTo.contact)
      this.vehicle.vehicleDetail.soldTo.contact = {};
  }

  @Watch("value")
  onValueChange(newVal) {
    this.vehicle = newVal;
  }

  soldAttachmentFile = null;
  soldAttachmentName = null;
  handleSoldAttachmentFileUpload(files) {
    if (files) {
      this.soldAttachmentFile = files[0];
    }
  }

  async uploadSoldFile() {
    try {
      common.setLoading(true);
      const formData = new FormData();

      if (this.id) {
        formData.set("fileName", this.soldAttachmentName);
      }
      if (this.isSet(this.soldAttachmentFile)) {
        formData.append("file", this.soldAttachmentFile);
      }
      const url =
        "/api/vehicle/" + this.vehicle._id + "/sold/attachment/upload";
      await doPostForm(url, formData);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      this.$emit("reload", true);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async deleteSoldImage(time, vehicle_id) {
    common.setLoading(true);
    if (time && vehicle_id) {
      try {
        await doGet(
          "/api/vehicle/" + vehicle_id + "/sold/attachment/" + time + "/delete"
        );
        common.showMessage("Removed Successfully !");
        this.$emit("reload", true);
      } catch (e) {
        common.setError(e.message);
      }
    }
    common.setLoading(false);
  }

  isPDF(_url) {
    if (_url && _url.includes(".pdf")) {
      return true;
    }
    return false;
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>